(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["theme-interactions"] && !Shopify.designMode) return;
  try {
    document.documentElement.classList.replace('no-js','js');
document.addEventListener('toggle',event=>{
  if(!event.target.matches('details[data-menu]')||!event.target.open)return;
  document.querySelectorAll('details[data-menu][open]').forEach(menu=>{if(menu!==event.target)menu.open=false;});
},true);
document.addEventListener('click',event=>{
  document.querySelectorAll('details[data-menu][open]').forEach(menu=>{if(!menu.contains(event.target))menu.open=false;});
  const quantityButton=event.target.closest('[data-quantity]');
  if(quantityButton){const input=quantityButton.parentElement.querySelector('input');if(quantityButton.dataset.quantity==='plus')input.stepUp();else input.stepDown();input.dispatchEvent(new Event('change',{bubbles:true}));}
  const thumbnail=event.target.closest('[data-gallery-image]');
  if(thumbnail){const main=document.querySelector('#ProductMainImage');if(main){event.preventDefault();main.srcset=thumbnail.dataset.gallerySrcset;main.src=thumbnail.dataset.galleryImage;main.alt=thumbnail.dataset.galleryAlt;}}
  if(event.target.closest('[data-close-notice]'))document.querySelector('#CartNotice').hidden=true;
});
document.addEventListener('keydown',event=>{
  if(event.key==='Escape'){const menus=[...document.querySelectorAll('details[data-menu][open]')];menus.forEach(menu=>{menu.open=false;menu.querySelector('summary').focus();});const notice=document.querySelector('#CartNotice');if(notice)notice.hidden=true;}
});
document.addEventListener('change',event=>{if(event.target.matches('[data-variant-select]'))event.target.form.requestSubmit();});
document.addEventListener('submit',async event=>{
  const form=event.target;
  if(!form.matches('[data-quick-add]'))return;
  event.preventDefault();
  const button=form.querySelector('button[type=submit]');
  if(button.disabled)return;
  const strings=document.querySelector('#ThemeStrings').dataset;
  const notice=document.querySelector('#CartNotice');
  const message=notice.querySelector('[data-cart-message]');
  button.disabled=true;button.setAttribute('aria-busy','true');
  try{
    const response=await fetch(strings.cartAdd+'.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
    const result=await response.json();
    if(!response.ok)throw new Error(result.description||strings.error);
    message.textContent=strings.added;notice.hidden=false;
    try{const cartResponse=await fetch(strings.cartUrl+'.js',{headers:{Accept:'application/json'}});if(cartResponse.ok){const cart=await cartResponse.json();document.querySelectorAll('[data-cart-count]').forEach(count=>count.textContent=cart.item_count);const cartLink=document.querySelector('.cart-link');if(cartLink)cartLink.setAttribute('aria-label',cartLink.getAttribute('aria-label').replace(/\(\d+\)/,'('+cart.item_count+')'));}}
    catch{}
  }catch(error){message.textContent=error.message||strings.error;notice.hidden=false;}
  finally{button.disabled=false;button.removeAttribute('aria-busy');}
});


(function(){
  const selector='[data-hotend-card-rating]';
  const stars=n=>{
    const r=Math.max(0,Math.min(5,Math.round(Number(n)||0)));
    return '★'.repeat(r)+'☆'.repeat(5-r);
  };
  async function fillBadge(el){
    if(el.dataset.hotendRatingLoaded==='1')return;
    el.dataset.hotendRatingLoaded='1';
    const productId=el.dataset.productId||'';
    if(!productId)return;
    try{
      const res=await fetch('/apps/hotend-hub/reviews?product_id='+encodeURIComponent(productId));
      if(!res.ok)return;
      const data=await res.json();
      if(!data.ok)return;
      const count=Number(data.count||0);
      const avg=count?Number(data.average||0):0;
      const s=el.querySelector('.hotend-card-rating__stars');
      const score=el.querySelector('.hotend-card-rating__score');
      const n=el.querySelector('.hotend-card-rating__count');
      if(s)s.textContent=stars(avg);
      if(score)score.textContent=avg.toFixed(1);
      if(n)n.textContent='('+count+')';
      el.setAttribute('aria-label',avg.toFixed(1)+' out of 5 from '+count+' review'+(count===1?'':'s'));
    }catch(e){}
  }
  const io='IntersectionObserver' in window?new IntersectionObserver(entries=>{
    entries.forEach(entry=>{
      if(!entry.isIntersecting)return;
      io.unobserve(entry.target);
      fillBadge(entry.target);
    });
  },{rootMargin:'300px 0px'}):null;
  function observe(root=document){
    const nodes=[];
    if(root.nodeType===1&&root.matches&&root.matches(selector))nodes.push(root);
    if(root.querySelectorAll)nodes.push(...root.querySelectorAll(selector));
    nodes.forEach(el=>{
      if(el.dataset.hotendRatingObserved==='1'||el.dataset.hotendRatingLoaded==='1')return;
      el.dataset.hotendRatingObserved='1';
      if(io)io.observe(el);else fillBadge(el);
    });
  }
  const start=()=>observe(document);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
  new MutationObserver(records=>{
    records.forEach(record=>record.addedNodes.forEach(node=>{if(node.nodeType===1)observe(node);}));
  }).observe(document.documentElement,{childList:true,subtree:true});
})();
  } catch(e) { console.error(e); }
})();

})();
